<template>
    <div>
        <router-view name="demandModal"></router-view>
        <v-card flat>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-btn
                    :loading="loading"
                    :disabled="loading"
                    color="purple"
                    :dark="!loading"
                    @click.prevent="loadData()"
                >
                    {{ $t('common.update') }}
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <data-table :setup.sync="dataTable"></data-table>
        </v-card>
    </div>
</template>

<script>
import API from '@/api'
import DataTable from '@/components/DataTable'

export default {
    name: 'inner-tab-demand-standby',
    components: {
        DataTable
    },
    vm: this,
    data: function (vm) {
        return {
            loading: true,
            dataTable: {
                loading: true,
                itemName: this.$t('labels.demand'),
                headers: [
                    { text: this.$t('common.tabDemands.dataTable.headers.startDate'), value: 'startDate', width: '10%', align: 'center', date: 'iso' },
                    { text: this.$t('common.tabDemands.dataTable.headers.demand'), value: 'demand', width: '55%' },
                    { text: this.$t('common.tabDemands.dataTable.headers.workedHours'), value: 'workedHours', width: '15%', align: 'center', sortable: false },
                    { text: this.$t('common.tabDemands.dataTable.headers.endDate'), value: 'endDate', width: '10%', align: 'center', date: 'iso' },
                    { text: this.$t('common.tabDemands.dataTable.headers.responsibleName'), value: 'responsibleName', width: '10%', align: 'center', background: 'responsible.profile.color' }
                ],
                items: [],
                totalItems: 0,
                requesterType: vm.$route.meta.requesterType,
                requesterId: undefined,
                detailTo: vm.$route.meta.detailTo,
                editTo: 'EditarDemanda',
                pagination: {
                    multiSort: true,
                    mustSort: false,
                    page: 1,
                    itemsPerPage: 500,
                    groupBy: [],
                    groupDesc: [],
                    sortBy: ['endDate', 'startDate', 'responsibleName', 'demand'],
                    sortDesc: [false, false, false, false],
                    sortFormated: [
                        { value: 'endDate', descending: false },
                        { value: 'startDate', descending: false },
                        { value: 'responsible', descending: false },
                        { value: 'demand', descending: false }
                    ]
                },
                footerProps: {
                    itemsPerPageOptions: [500, 250, 100, 50, 25, 10]
                }
            }
        }
    },
    watch: {
        'dataTable.pagination.sortBy': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.dataTable.sortingTimeout !== undefined) clearTimeout(this.dataTable.sortingTimeout)
                    this.dataTable.sortingTimeout = setTimeout(() => {
                        let sortView = {
                            order: this.dataTable.pagination.sortFormated
                        }
                        this.$helpers.setClientSortDemandStandbyView(sortView)
                        this.loadData()
                    }, 1000)
                }
            },
            deep: true
        },
        'dataTable.pagination.page': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.itemsPerPage': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        '$route': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (window.getApp.refreshDemands) this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        if (this.$route.name === `${this.$route.meta.singleName}AbaInternaDemandasStandby`) this.loadData()
    },
    methods: {
        async loadData () {
            await this.$helpers.sleep(0)
            window.getApp.refreshDemands = false
            this.loading = true
            this.dataTable.loading = true
            this.dataTable.items = []
            this.dataTable.requesterId = this.$route.params.id
            let endpoint = API.EndPoints.getDemandsByisDone
            let sortView = JSON.parse(localStorage.getItem('clientSortDemandsStandby'))

            if (sortView === null) {
                sortView = {
                    order: this.dataTable.pagination.sortFormated
                }
            }

            let data = {
                objectId: this.$route.params.id,
                isEmployee: false,
                isDone: false,
                isStandBy: true,
                params: {
                    limit: this.dataTable.pagination.itemsPerPage,
                    skip: this.dataTable.pagination.page - 1,
                    order: this.dataTable.pagination.sortFormated
                }
            }
            new API(endpoint, data).request().then(response => {
                this.$helpers.setClientSortDemandStandbyView(sortView)
                this.dataTable.items = response.body.result.items
                this.dataTable.totalItems = response.body.result.count
                this.loading = false
                this.dataTable.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        }
    }
}
</script>
